import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { ResetTabIndex, TabIndexChange } from '../actions/details.actions';
import { MerchantDetailsState } from '../models/merchant.model';

const initialState: MerchantDetailsState = {
  tabIndex: 0,
};

export const MerchantDetailsReducer = createReducer(
  initialState,
  on(TabIndexChange, (state) => ({
    ...state,
    tabIndex: 1,
  })),
  on(ResetTabIndex, (state) => ({
    ...state,
    tabIndex: 0,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
